var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('div',{staticClass:"home"},[_c('h1',[_vm._v("Welcome to the Collect App!")]),(!_vm.loggedIn)?_c('div',[_vm._v(" To use this app you'll need to "),_c('router-link',{attrs:{"to":"/login"}},[_vm._v("login")])],1):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }